var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPen = function SvgFadPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 160v64l65.348-.41 132.53-133.008a4.034 4.034 0 0 0 .007-5.676l-57.837-58.237a4.001 4.001 0 0 0-5.654-.026L32 160z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.797 165.594V208h40.488l121.92-121.396L180.57 56.56 64.656 175.772a3.937 3.937 0 0 1-5.624.037l-10.235-10.215z",
    fill: "#FFF"
  }))));
};
export { SvgFadPen as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-pen.03b8e935.svg";